<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Add/Update 4Over Products </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="categoryId"
                :items="categories"
                item-text="name"
                item-value="id"
                label="Category"
                hide-details="auto"
                outlined
                :rules="[$rules.required]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <v-divider />
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Add4OverProduct',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      categoryId: null,
      externalIds: []
    };
  },

  computed: {
    ...mapGetters({
      fourover_list: 'print/fourover_list',
      print_lookups: 'print/lookups',
      categories: 'lookup/non_parent_categories'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.ADD_4OVER_PRODUCTS_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.ADD_4OVER_PRODUCTS_SHOW, (data) => {
      this.categoryId = null;
      this.externalIds = data.externalIds;
      this.drawer = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('print/addFourOverProducts', {
          externalIds: this.externalIds,
          categoryId: this.categoryId
        })
        .then(() => {
          this.$root.$snackbarSuccess('Print Products added');
          this.$emit('save');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
